import env from '@upgrade/ui-utils/env';

import { withOptions } from '@upgrade/ui-utils/api/fetch-json';

const baseUrl = env.GATSBY_FUNNEL_API_ENDPOINT;

// eslint-disable-next-line import/prefer-default-export
export const { fetchJson, postJson } = withOptions({
  baseUrl,
  headers: { 'X-CF-SOURCE-ID': 'public-site-cms-ui' }
});
